
import { Component, Mixins } from "vue-property-decorator";
import { BrowserUtility, BrowserKinds } from "../../../utilities";

@Component
export default class PdfStyleDrawableMixin extends Mixins() {
  get pdfStyle(): any {
    return {
      backgroundColor: this.shouldRenderSelf
        ? "#98948d"
        : BrowserUtility.getBrowserKind() === BrowserKinds.InternetExplorer
          ? "#999999"
          : "#525659"
    };
  }

  private get shouldRenderSelf(): boolean {
    return this.$configuration.system.pdfRendering.shouldRenderSelf;
  }
}
